/*
 *
 * Copyright (c) 2025 Alexander Orlov.
 * 34 Middletown Ave, Atlantic Highlands, NJ 07716
 *
 * THIS SOFTWARE IS THE CONFIDENTIAL AND PROPRIETARY INFORMATION OF
 * Alexander Orlov ("CONFIDENTIAL INFORMATION").
 *
 * Author: Alexander Orlov
 * Aegis AO Soft
 *
 */

/**
 * Compatibility bridge: re-exports AES functions under aa-web names.
 *
 * aegis-aa-web uses:   import { encryptForApi } from '../utils/crypto';
 * owner-web has:       utils/aes.ts with aesEncrypt / aesDecrypt
 */

import { aesEncrypt, aesDecrypt } from './aes';

export const encryptForApi = aesEncrypt;
export const decryptFromApi = aesDecrypt;
